<template>
  <v-layout column style="width: 100%;">
    <v-layout row>
      <v-flex lg3 md4 sm6>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDate"
              label="Start Date"
              prepend-icon="event"
              readonly
              v-on="on"
              dense
            ></v-text-field>
          </template>
          <v-date-picker no-title v-model="startDate" @input="menu = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex lg3 md4 sm6>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endDate"
              label="End Date"
              prepend-icon="event"
              readonly
              v-on="on"
              dense
            ></v-text-field>
          </template>
          <v-date-picker no-title v-model="endDate" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <GChart
      @ready="onChartReady"
      type="ColumnChart"
      :data="chartData"
      :options="chartOptions"
      :events="chartEvents"
    />
    <GChart
      @ready="onTimelineReady"
      :settings="{ packages: ['corechart', 'table', 'map', 'timeline'] }"
      type="Timeline"
      :options="timelineOptions"
    />
  </v-layout>
</template>

<script>
import moment from "moment";
import { GChart } from "vue-google-charts";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "timesheet",
  components: {
    GChart
  },
  props: {
    driver: Object
  },
  watch: {
    startDate: function() {
      this.getWorkingHours();
    },
    endDate: function() {
      this.getWorkingHours();
    }
  },
  data() {
    return {
      timeGaps: null,
      chart: null,
      timeline: null,
      menu: false,
      menu2: false,
      chartData: null,
      chartOptions: {
        chart: {
          title: "Hours Worked"
        },
        colors: ["#03A9F4", "#009688", "#FFEB3B", "#795548"],
        width: "100%",
        height: 400,
        legend: { position: "top", maxLines: 3 },
        bar: { groupWidth: "90%" },
        isStacked: true,
        axes: {
          y: {
            0: { side: "left", label: "No. Of Hours" } // Top x-axis.
          }
        }
      },
      timelineOptions: {
        width: "100%",
        height: 300,
        timeline: { colorByRowLabel: true }
      },
      timelineData: null,
      chartEvents: {
        select: () => {
          console.log(this.chart.getSelection());

          if (this.chart.getSelection()[0] == null) {
            return;
          }

          var row = this.chart.getSelection()[0].row;

          this.getStateBreakdownForDay(row);
        }
      },
      endDate: moment()
        .startOf("day")
        .add(1, "days")
        .toDate()
        .toISOString()
        .substr(0, 10),
      startDate: moment()
        .startOf("day")
        .subtract(10, "days")
        .toDate()
        .toISOString()
        .substr(0, 10)
    };
  },
  mounted: function() {
    this.getWorkingHours();
  },
  methods: {
    onChartReady(chart, google) {
      this.chart = chart;
    },
    onTimelineReady(timeline, google) {
      this.timeline = timeline;
      this.getStateBreakdownForDay(0);
    },
    getStateBreakdownForDay(day) {
      var start = moment(this.startDate, "YYYY-MM-DD")
        .add(day + 1, "days")
        .toDate()
        .toISOString()
        .substr(0, 10);
      var end = moment(this.startDate, "YYYY-MM-DD")
        .add(day + 2, "days")
        .toDate()
        .toISOString()
        .substr(0, 10);

      console.log(start + " " + end);

      this.getStateBreakdown(start, end);
    },
    getWorkingHours() {
      let url = `${this.$store.state.apiUrl}/driver/getTimesheetDailyBreakdown?driver_id=${this.driver.id}&start_date=${this.startDate} 00:00&end_date=${this.endDate} 00:00`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error != "no_error") {
            alert(res.data.error.message);
            return;
          }

          console.log(res.data.timesheets);

          vm.chartData = [
            ["State", "Online", "On-Break", "On Way to Job", "POB"]
          ];

          var ts = res.data.timesheets;

          for (var i = 0; i < ts.length; i++) {
            vm.chartData.push([
              ts[i]["start_time"].substr(0, 10),
              ts[i]["hours_waiting_for_job"],
              ts[i]["hours_on_break"],
              ts[i]["hours_on_job"],
              ts[i]["hours_pob"]
            ]);
          }
        })
        .catch(function(err) {
          console.error(err);
          self.loading = false;
        });
    },
    getStateBreakdown(startDate, endDate) {
      let url = `${this.$store.state.apiUrl}/driver/getBreakdownOfDriverState?driver_id=${this.driver.id}&start_date=${startDate} 00:00&end_date=${endDate} 00:00`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error != "no_error") {
            alert(res.data.error.message);
            return;
          }

          console.log(res.data.state_changes);

          var stcs = res.data.state_changes;

          vm.timelineData = [];

          const dataTable = new google.visualization.DataTable();

          dataTable.addColumn({ type: "string", id: "Role" });
          dataTable.addColumn({ type: "string", id: "Name" });
          dataTable.addColumn({ type: "string", id: "style", role: "style" });
          dataTable.addColumn({ type: "date", id: "Start" });
          dataTable.addColumn({ type: "date", id: "End" });

          // "Waiting for Job", "On Break", "On Job", "POB"
          // ['#03A9F4', '#009688', '#FFEB3B', '#795548']
          for (var i = 0; i < stcs.length; i++) {
            var stc = stcs[i];

            var namedState = "";
            var color = "";
            var state = stc.new_state;

            if (state == "on_break") {
              namedState = "On Break";
              color = "#009688";
            } else if (state == "available" || state == "job_sent") {
              namedState = "Online";
              color = "#03A9F4";
            } else if (state == "on_job") {
              namedState = "On Way to Job";
              color = "#FFEB3B";
            } else if (state == "pob") {
              namedState = "POB";
              color = "#795548";
            } else {
              namedState = "Offline";
              color = "#ababab";
              continue;
            }

            var stcStart = moment(stc.start_time, "YYYY-MM-DD HH:mm").toDate();
            var stcEnd = moment(stc.end_time, "YYYY-MM-DD HH:mm").toDate();

            dataTable.addRow([namedState, "", color, stcStart, stcEnd]);

            vm.timeline.draw(dataTable);
          }
        })
        .catch(function(err) {
          console.error(err);
          self.loading = false;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
